<script setup lang="ts">
import {  RouterView } from 'vue-router'
import { useGlobalStore } from '@/stores/global'
import { useIsFetching, useIsMutating, useQueryClient } from '@tanstack/vue-query'
import type { ComponentExposed } from 'vue-component-type-helpers'
import { provide, ref, type Component } from 'vue'
import AwaitableModal from './components/shared/AwaitableModal.vue'
import Button from './components/Button.vue'
import { useTrackingSession } from './services/tracking-sessions'

const appStore = useGlobalStore()

const isFetching = useIsFetching()
const isMutating = useIsMutating()
const queryClient = useQueryClient()

const awaitableModal = ref<null | ComponentExposed<typeof AwaitableModal>>(null)

function cancel() {
  queryClient.cancelQueries()
}

useTrackingSession()

provide('modal', awaitableModal)
</script>

<template>
  <template v-if="isFetching || appStore.loading || isMutating">
    <div class="fixed w-screen h-screen top-0 left-0 bg-black bg-opacity-50 z-[99]" />
    <div
      class="fixed bg-white dark:bg-gray-800 rounded-lg p-5 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-[99] flex flex-col gap-3 items-center w-full max-w-xs"
    >
      <span class="icon-[eos-icons--loading] size-6 dark:text-gray-200"></span>
      <div class="dark:text-gray-200">جاري التحميل</div>

      <Button @click="cancel" type="outline-danger"> إلغاء </Button>
    </div>
  </template>

  <AwaitableModal ref="awaitableModal" />

  <RouterView :key="$route.fullPath" />
</template>

<style>
.router-link-active {
  @apply bg-white dark:bg-gray-700 text-primary dark:text-blue-400 rounded-lg fill-primary dark:fill-blue-400;
}

.dp__theme_light {
  --dp-primary-color: var(--color-primary);
}

.dp__theme_dark {
  --dp-primary-color: var(--color-primary);
  --dp-background-color: #1f2937;
}
</style>
